import { getRequest } from '@/core';
import { tripChangelogs } from '@/requests';

export default async function getTripChangelogRequest(id) {
	let url = tripChangelogs.getByIdPath(id);
	let response = await getRequest(url);
	return response;
}
